import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, ValidationErrors, UntypedFormControl } from '@angular/forms';
import { TeamValidators } from 'src/app/core/validators/team.validators';
import { Observable } from 'rxjs';
import { merge } from 'lodash';
import { TeamRoleEdit } from '../../model/team-role';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';

@Component({
  selector: 'app-team-role-edit',
  templateUrl: './team-role-edit.component.html',
  styleUrls: ['./team-role-edit.component.scss']
})
export class TeamRoleEditComponent implements OnInit
{
  @Input() public isNew = false;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<TeamRoleEdit> = new EventEmitter();

  public editForm: any;
  public editFormActive = false;
  public codeSets: any[];

  private teamRoleEdit: TeamRoleEdit;

  constructor(
    private fb: UntypedFormBuilder,
    private teamValidators: TeamValidators,
    private dictionaryService: DictionaryService,
    private messageHandlerService: MessageHandlerService)
  { }

  public get name(): UntypedFormControl
  {
    return this.editForm.get('name');
  }

  public get description(): UntypedFormControl
  {
    return this.editForm.get('description');
  }

  public get active(): UntypedFormControl
  {
    return this.editForm.get('active');
  }

  public get teamType(): UntypedFormControl
  {
    return this.editForm.get('teamType');
  }

  @Input() public set model(teamRole: TeamRoleEdit)
  {
    this.initModel(teamRole);
  }

  public ngOnInit(): void
  {
    // Load CodeSets
    this.dictionaryService.getCachedCodeSets().subscribe({
      next: (data) =>
      {
        this.codeSets = data;
      },
      error: (error) =>
      {
        this.messageHandlerService.displayError(error);
      }
    });
  }

  public onSave(e: Event): void
  {
    e.preventDefault();
    const objectToPersist = merge(this.teamRoleEdit, this.editForm.value);

    if (this.teamType.value === undefined || this.teamType.value === null)
    {
      objectToPersist.teamType = null;
    }

    this.save.emit(objectToPersist);
    this.editFormActive = false;
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeEditForm();
  }

  private closeEditForm(): void
  {
    this.editFormActive = false;
    this.cancelling.emit();
  }

  private initModel(teamRole: TeamRoleEdit)
  {
    if (teamRole === undefined)
    {
      return;
    }
    // Set the current category id used for name async validators
    const previousTeamRoleName = this.isNew ? '' : teamRole.name;

    // Set form
    this.editForm = this.fb.group({
      id: [teamRole.id],
      name: [
        { value: '', disabled: false },
        {
          validators: [Validators.required],
          asyncValidators: (): Observable<ValidationErrors | null> =>
            this.teamValidators.validateTeamRoleNameUnique(this.editForm.get('name'), previousTeamRoleName)
        }
      ],
      active: { value: teamRole.active, disabled: false },
      pcp: { value: teamRole.pcp, disabled: false },
      description: { value: teamRole.description, disabled: false },
      teamType: { value: teamRole.teamType !== null ? teamRole.teamType : null, disabled: false }
    });

    this.teamRoleEdit = teamRole;
    this.name.setValue(teamRole.name);  // This is a work around to fix asyncValidators
    this.editFormActive = teamRole !== undefined;
  }
}
